import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberShip: "",
  activeMembershipTab: 0,
  activeCardTab: "",
};

const membershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    setMemberShip: (state, action) => ({
      ...state,
      memberShip: action.payload,
    }),
    setActiveMembershipTab: (state, action) => ({
      ...state,
      activeMembershipTab: action.payload,
    }),
    setActiveCardTab: (state, action) => ({
      ...state,
      activeCardTab: action.payload,
    }),
  },
});

export const { setMemberShip, setActiveMembershipTab, setActiveCardTab } =
  membershipSlice.actions;
export default membershipSlice;
